import React, { useEffect, useCallback } from "react";
import UsePanel from "./UserPanel";
import { Row, Container, Col } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { getDashboardData } from "../../store/actions/dashboard";
import { Spin } from "antd";
import NewCustomersTable from "./NewCustomersTable";
import CustomerPanel from "./CustomerPanel";

const Dashboard = () => {
  const dispatch = useDispatch();

  const dashboard = useSelector((state) => state.dashboard);
  useEffect(() => {
    document.title = "Dashboard | 09TAX - Admin Dashboard ";
  }, []);

  const loadDashboardData = useCallback(async () => {
    await Promise.all([dispatch(getDashboardData())]);
  }, [dispatch]);

  useEffect(() => {
    loadDashboardData();
  }, [loadDashboardData]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="09TAX" breadcrumbItem="Dashboard" />

          {false ? (
            <div className="text-center py-5">
              <Spin size="large" tip="Loading Dashboard data..." />
            </div>
          ) : (
            <>
              {/* Top Stats Panel */}
              <UsePanel totalCustomer={dashboard?.state?.totalCustomer} totalBusinessType={dashboard?.state?.totalBusinessType} totalPackage={dashboard?.state?.totalPackage} />

              <Row>
                {/* Revenue/Profit Charts */}
                {/* <OverView order={[]} /> */}
                {/* <SocialSource /> */}
              </Row>

              {/* Transactions & Customer Lists */}
              {/* <LatestTransation order={[]} /> */}
              <NewCustomersTable customer={dashboard?.recentCustomers} />

              {/* Individual Management Panels */}
              <Row>
                <Col xl={4}>
                  <CustomerPanel />
                </Col>
                {/* <Col xl={4}>
                  <ProductsPanel />
                </Col>
                <Col xl={4}>
                  <OrdersPanel />
                </Col> */}
              </Row>
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
